var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isCountdownComplete)?_c('span',{staticClass:"resend-text",on:{"click":_vm.onClickResendCode}},[_vm._v("Resend code")]):_c('span',{staticClass:"text-xs font-medium"},[_vm._v("Resend code in "),_c('b',{staticClass:"countdown-text"},[_vm._v(_vm._s(_vm.timeLeft))])])
}
var staticRenderFns = []

export { render, staticRenderFns }